import {
  WIDGET_DEFAULT_COLOR,
  WIDGET_DEFAULT_POSITION,
  WIDGET_DEFAULT_STYLE,
} from "../../../utils/constants";

export const appearanceModel = {
  color: WIDGET_DEFAULT_COLOR,
  position: WIDGET_DEFAULT_POSITION,
  style: WIDGET_DEFAULT_STYLE,
};
export const soundsModel = {
  active_visitor_sound: "/active-visitor.mp3",
  active_visitor_volume: 37,
  new_chat_sound: "/ding.mp3",
  new_chat_volume: 30,
};
export const platformRestrictionModel = {
  enabled: false,
  type: 0,
  values: [],
};

export const hoursRestrictionModel = {
  enabled: false,
  values: [],
};
export const countryRestrictionModel = {
  enabled: false,
  type: 0,
  values: [],
};

export const domainRestrictionModel = {
  enabled: false,
  type: 0,
  values: "",
};
export const selection_dropdown = [
  {
    value: 0,
    label: "Show Widget only to visitors of the following",
  },
  {
    value: 1,
    label: "Hide Widget only from visitors of the following",
  },
];

export const platforms = [
  {
    label: "Desktop",
    value: "desktop",
  },
  {
    label: "Mobile",
    value: "mobile",
  },
];

export const msgPreview = {
  desktop: true,
  mobile: true,
};
